__turbopack_context__.v({
  "bounce1": "qF36ia_bounce1",
  "bounce2": "qF36ia_bounce2",
  "bounce3": "qF36ia_bounce3",
  "bounce4": "qF36ia_bounce4",
  "dot1": "qF36ia_dot1",
  "dot2": "qF36ia_dot2",
  "dot3": "qF36ia_dot3",
  "dot4": "qF36ia_dot4",
  "loader": "qF36ia_loader",
});
